import { Component, OnInit } from '@angular/core'
import { InlineEditCellDirective } from '../inline-edit-cell'

@Component({
  selector: 'jml-lib-icon-picker-cell',
  templateUrl: './icon-picker-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class IconPickerCellComponent extends InlineEditCellDirective implements OnInit {
  ngOnInit(): void {}

  triggerEdit() {
    setTimeout(() => {
      this.originalContent = this.rowData[this.fieldName]
      this.isEdited = true
    }, 0)
  }

  onIconPicked(icon: string) {
    // fas fa-user is the default value used when no preselected icon is given
    // For some reason the ngx-icon-picker emits a pick event on initial loading
    // Since fas fa-user is not a valid icon in the current configuration we can just filter this event out
    if (icon !== 'fas fa-user') {
      this.isEdited = false
      this.rowData[this.fieldName] = icon
      this.completeCellEdit.emit({ data: this.rowData, field: this.fieldName })
    }
  }
}
